import { render, staticRenderFns } from "./MapCharacterPiece.vue?vue&type=template&id=01935f0e&scoped=true&lang=pug&"
import script from "./MapCharacterPiece.vue?vue&type=script&lang=js&"
export * from "./MapCharacterPiece.vue?vue&type=script&lang=js&"
import style0 from "./MapCharacterPiece.vue?vue&type=style&index=0&id=01935f0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01935f0e",
  null
  
)

component.options.__file = "MapCharacterPiece.vue"
export default component.exports